<template>
    <div>
        <div id="versionDetail">
            <el-dialog title="关于" :visible.sync="dialogVisible" :width="'650px'" :before-close="taskPanelClose">
                <div class="about_box">
                    <div class="about_left"><img :src="desysLogo.mainLogo"></div>
                    <div class="about_right">
                        <div>{{ desysLogo.loginTitle }}</div>
                        <div>注册单位：{{ desysLogo.registerName }}</div>
                        <div>使用单位：{{ userDep }}</div>
                        <div>版本号：{{ desysLogo.versionNum }}</div>
                        <div >有效期：{{ this.ormList.authDate ? this.$common.getLocalTime(this.ormList.authDate) :'长期'  }}</div>
                        <!-- <div>服务网站：</div> -->
                        <div>客服电话：400-9016196 </div>
                        <div>版权所有@ {{ desysLogo.copyright }}</div>
                    </div>
                </div>
                <div class="about_info">
                    <div>
                        警告:本软件受版权保护法和软件使用许可证的保护。未经合法授权，任何单位或个人均不得复制、解密、制售此软件的全部或部分，否则，将要承担法律责任。
                    </div>
                </div>
            </el-dialog>
        </div>


    </div>
</template>

<script>
export default {
    name: 'versionDetail',
    props: {
    },
    components: {
    },
    data() {
        return {
            dialogVisible: false,
            desysLogo: {},
            ormList: {},
            userDep: ''
        }
    },
    methods: {
        taskPanelClose() {
            this.$emit('helpClose', this.dialogVisible)
        },
    },
    created() {//拿数据
        this.dialogVisible = true
        this.desysLogo = JSON.parse(sessionStorage.getItem('desysLogo'))
        this.ormList = JSON.parse(sessionStorage.getItem('ormList'))
        this.userDep = sessionStorage.getItem('ormName')
      
    },
}
</script>

<style scoped>
.about_box {
    height: 200px;
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    border-top: 1px solid #c5c3c3;
    /* font-weight: 600; */
    color: #fff;
}

.about_left {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.about_left img {
    /* background-color:#d1d1d1; */
    width: 280px;
    /* background-color: #eceef5; */
}

.about_info {
    width: 100%;
    padding: 0 10px 10px 10px;
    text-align: left;
}

.about_right {
    padding: 10px 0 10px 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

}

.about_info div {
    border-top: 1px solid #c5c3c3;
    padding-top: 5px;
    color: #fff;
}
</style>
<style>
#versionDetail .el-dialog__header {
    background-color: #705fa1;
    /* background-color:#d1d1d1; */
    /* background-color: #eceef5; */

}

#versionDetail .el-dialog__body {
    /* color: #000; */
    background-color: #705fa1;
    /* background-color:#d1d1d1; */
    /* background-color: #eceef5; */

}

#versionDetail .el-dialog__title {
    color: #fff;
}
#versionDetail .el-dialog__close  {
    /* color: #fff;
    font-size: 24px;
    margin: 10px; */
}
</style>
